import React from 'react';
import { useParams } from 'react-router-dom';
import { useMutation, useQuery } from '@apollo/client';
import {
  GET_PROJECT_CATEGORIES,
  UPDATE_PROJECT_CATEGORY,
} from '../../../gql/projectCategories';
import { Spin, message, Typography } from 'antd';
import ProjectCategoryForm from './ProjectCategoryForm';

const { Text } = Typography;

const TabBasic = () => {
  const { id } = useParams();
  const { data, loading } = useQuery(GET_PROJECT_CATEGORIES, {
    variables: { ids: [id], state: 'ALL' },
  });
  const [updateProjectCategory, { loading: mutationLoading }] = useMutation(
    UPDATE_PROJECT_CATEGORY,
    {
      refetchQueries: [
        { query: GET_PROJECT_CATEGORIES, variables: { state: 'ALL' } },
        { query: GET_PROJECT_CATEGORIES },
      ],
      onCompleted: ({ updateProjectCategory }) => {
        message.success(`${updateProjectCategory.name} successfully edited`);
      },
      onError: (err) => {
        console.log(err);
      },
    }
  );

  return (
    <Spin spinning={mutationLoading} tip="Updating...">
      <Text
        type="secondary"
        style={{ display: 'block', paddingBottom: '16px' }}
      >
        Contains basic info of the project category
      </Text>
      {!loading && (
        <ProjectCategoryForm
          initialValues={{
            name: data.projectCategories[0].name,
            workProgrammeFrom: data.projectCategories[0].workProgrammeFrom,
            workProgrammeTo: data.projectCategories[0].workProgrammeTo,
            virementThreshold: data.projectCategories[0].virementThreshold,
            seq: data.projectCategories[0].seq,
            active: !data.projectCategories[0].disabled,
          }}
          onFinish={(input) => {
            const {
              name,
              workProgrammeFrom,
              workProgrammeTo,
              virementThreshold,
              active,
              seq,
            } = input;
            updateProjectCategory({
              variables: {
                updateProjectCategoryInput: {
                  id,
                  name,
                  workProgrammeFrom,
                  workProgrammeTo,
                  virementThreshold,
                  seq,
                  disabled: !active,
                  deleted: false,
                },
              },
            });
          }}
          isEdit={true}
        />
      )}
    </Spin>
  );
};

export default TabBasic;
